import { motion, useScroll, useTransform } from "framer-motion";

export default function PageHero({ title, subtitle, image, testId }) {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 400], [0, 80]);

  return (
    <section
      className="relative isolate overflow-hidden"
      aria-label={title}
      data-testid={testId}
    >
      <motion.div
        style={{ y }}
        className="absolute inset-0"
        data-testid={`${testId}-parallax-layer`}
      >
        <motion.img
          src={image}
          alt={title}
          className="h-[45vh] min-h-[320px] w-full object-cover"
          animate={{ scale: [1.02, 1.08, 1.02] }}
          transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
          loading="eager"
          data-testid={`${testId}-image`}
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/80 via-[#1a1a1a]/55 to-[#1a1a1a]/35" />
      <div className="absolute inset-x-10 bottom-6 h-px animate-gold-sheen bg-gradient-to-r from-transparent via-[#f2e6c9] to-transparent" />
      <div className="relative mx-auto flex h-[45vh] min-h-[320px] w-full max-w-7xl flex-col justify-end px-6 pb-12 md:px-12 lg:px-16">
        <h1
          className="font-[Playfair_Display] text-4xl text-white sm:text-5xl lg:text-6xl"
          data-testid={`${testId}-title`}
        >
          {title}
        </h1>
        <p
          className="mt-4 max-w-3xl font-[Manrope] text-sm text-[#f2e6c9] md:text-lg"
          data-testid={`${testId}-subtitle`}
        >
          {subtitle}
        </p>
      </div>
    </section>
  );
}
